import { translate } from '@core/translate';
import { AbstractInput /* InputValidityState */ } from '@rxdi/forms';
import { html } from '@rxdi/lit-html';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function InputErrorTemplate(input: any) {
  if (input && input.touched && !input.validity.valid) {
    const message = input.validationMessage;
    // const key = Object.keys(InputValidityState).filter(o => input.validity[o])[0];
    // message = translate(key, 'bg_BG');
    input.classList.add('is-invalid');
    return html`
      <style>
        .validation-error {
          color: #a94442;
          font-size: 12px;
        }
      </style>
      <span style="padding-top: 5px;color: #a94442" class="validation-error">${translate(message)}</span>
    `;
  }
  input && input?.classList?.remove('is-invalid');
  return '';
}
